<template>
  <div
    class="slot-panel d-flex flex-wrap align-items-center"
    style="gap: 4px"
  >
    <div
      v-for="slot in slots"
      :key="slot.number"
      v-b-tooltip.hover
      class="slot-chip"
      :class="{
        'slot-occupied': !!slot.question,
        'slot-current': slot.number === currentSlot,
      }"
      :title="slot.question ? slot.question.answer : 'Свободный слот'"
      @click="$emit('slot-clicked', slot.number)"
    >
      {{ slot.price }}
    </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { VBTooltip } from 'bootstrap-vue'
import { defaultFlatPrice } from './gameBuilderPricing'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    currentRt: {
      type: Object,
      required: true,
    },
    currentSlot: {
      type: Number,
      default: null,
    },
  },
  setup(props) {
    const slots = computed(() => {
      const required = props.currentRt.required_questions || 5
      const basePrice = (props.currentRt.round && props.currentRt.round.base_price) || 100
      const questions = props.currentRt.questions || []

      return Array.from({ length: required }, (unused, index) => {
        const number = index + 1
        const price = props.currentRt.price_scale === 'flat'
          ? (Number(props.currentRt.flat_price) || defaultFlatPrice(basePrice))
          : basePrice * number

        return {
          number,
          price,
          question: questions.find(question => question.order === number) || null,
        }
      })
    })

    return { slots }
  },
}
</script>

<style scoped>
.slot-chip {
  min-width: 40px;
  height: 24px;
  padding: 0 6px;
  border-radius: 4px;
  border: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #6e6b7b;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.slot-chip.slot-occupied {
  background-color: rgba(40, 199, 111, 0.16);
  border-color: #28c76f;
  color: #28c76f;
}

.slot-chip.slot-current {
  border-color: #7367f0;
  border-width: 2px;
  box-shadow: 0 0 6px rgba(115, 103, 240, 0.5);
}
</style>
